module.exports = __webpack_public_path__ + "img/logo.1dccdd6c.png";